import {
  all, call, put, takeLatest,
} from 'redux-saga/effects';
import * as constants from 'redux/constants/app.constants';
import * as cartConstants from 'redux/constants/cart.constants';
import {
  getMinimumPurchase, getAllSliders, getWhatsapp, getDiscount, getCatalogs, getPrices, getInstagram,
  getDataAnalytics, getshowMPButton, getTransferInfo, getClient, getEnvios, getOnlyUsers, getInitialData,
  getAddresses,
} from 'services/app.services';
import { setRuntimeClients } from 'constants/clients';
import { categoryGetAll, cartelHomeGet, categoryHomeGet, marcasHomeGet } from './category.sagas';
import { productGetMaxPrice, productGetOffers, productGetNewArrivals, productGetMostSelled } from './product.sagas';
import { userProfile } from './user.sagas';
import { subCategoryGetAll, subCategoryHomeGet } from './subCategory.sagas';

export function* loadInitialData(action) {
  try {
    const payload = action?.payload || {};
    const data = yield call(getInitialData, payload);
    yield all([
      call(safeCall, minimumPurchaseGet, data.minimumAmount.original),
      call(safeCall, slidersGetAll, data.sliders.original),

      call(safeCall, categoryGetAll, data.categories.original),
      call(safeCall, categoryHomeGet, data.categoryHome.original),
      call(safeCall, marcasHomeGet, data.marcasHome.original),
      call(safeCall, cartelHomeGet, data.cartelHome.original),

      call(safeCall, subCategoryGetAll, data.subcategories.original),
      call(safeCall, subCategoryHomeGet, data.subcategoriesHome.original),

      call(safeCall, userProfile, data.profile.original),

      call(safeCall, productGetMaxPrice, data.maxPrice.original),
      call(safeCall, productGetOffers, data.offers.original),
      call(safeCall, productGetNewArrivals, data.newArrivals.original),
      call(safeCall, productGetMostSelled, data.mostSelled.original),

      call(safeCall, enviosGet, data.envios.original),
      call(safeCall, whatsappGet, data.whatsapp.original),
      call(safeCall, catalogsGet, data.catalogs.original),
      call(safeCall, pricesGet, data.prices.original),
      call(safeCall, dataAnalyticsGet, data.dataAnalytics.original),
      call(safeCall, discountGet, data.discounts.original),
      call(safeCall, instagramGet, data.socialMedia.original),
      call(safeCall, transferInfoGet, data.transferInfo.original),
      call(safeCall, clientGet, data.design.original),
      call(safeCall, publicKeyMPGet, data.publicKeyMP.original),
      call(safeCall, clientsGet, data.clients),
      call(safeCall, cuotasMPGet, data.cuotasMP),
      call(safeCall, paymentMethodsGet, data.paymentMethods.original),
      call(safeCall, addressesGet, data.addresses.original),
      call(safeCall, frequentQuestionsGet, data.frequentQuestions?.original),
    ]);
  } catch (error) {
    console.log("error:" ,error);
    const errorMessage = "Disculpe las molestias, estamos trabajando para restablecer la web. Pruebe en breve o comuníquese por WhatsApp. \n"
    yield put({type: constants.APP_INITIALIZE_FAILED, data : errorMessage});
  }
}

export function* safeCall(fn, ...args) {
  try {
    yield call(fn, ...args);
  } catch (error) {
    console.error(`Error en ${fn.name}:`, error);
  }
}

export function* minimumPurchaseGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const minimumAmount = !isReduxAction && data ? data : yield call(getMinimumPurchase);
    yield put({ type: constants.APP_MINIMUM_PURCHASE_SUCCEEDED, data : minimumAmount });
  } catch (error) {
    yield put({ type: constants.APP_MINIMUM_PURCHASE_FAILED, error });
  }
}
export function* discountGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const discounts = !isReduxAction && data ? data : yield call(getDiscount);
    yield put({ type: constants.APP_DISCOUNT_SUCCEEDED, data : discounts });
  } catch (error) {
    yield put({ type: constants.APP_DISCOUNT_FAILED, error });
  }
}

export function* slidersGetAll(data = null) {
  try {
    const isReduxAction = data && data.type;
    const sliders = !isReduxAction && data ? data : yield call(getAllSliders);
    yield put({ type: constants.APP_SLIDERS_GET_ALL_SUCCEEDED, data : sliders });
  } catch (error) {
    yield put({ type: constants.APP_SLIDERS_GET_ALL_FAILED, error });
  }
}

export function* whatsappGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const whatsapp = !isReduxAction && data ? data : yield call(getWhatsapp);
    yield put({ type: constants.APP_WHATSAPP_SUCCEEDED, data : whatsapp });
  } catch (error) {
    yield put({ type: constants.APP_WHATSAPP_FAILED, error });
  }
}

export function* instagramGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const instagramGet = !isReduxAction && data ? data : yield call(getInstagram);
    yield put({ type: constants.APP_INSTAGRAM_SUCCEEDED, data : instagramGet });
  } catch (error) {
    yield put({ type: constants.APP_INSTAGRAM_FAILED, error });
  }
}

export function* catalogsGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const catalogs = !isReduxAction && data ? data : yield call(getCatalogs);
    yield put({ type: constants.APP_CATALOGS_SUCCEEDED, data : catalogs });
  } catch (error) {
    yield put({ type: constants.APP_CATALOGS_FAILED, error });
  }
}

export function* pricesGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const prices = !isReduxAction && data ? data : yield call(getPrices);
    yield put({ type: constants.APP_PRICES_SUCCEEDED, data : prices });
  } catch (error) {
    yield put({ type: constants.APP_PRICES_FAILED, error });
  }
}

export function* dataAnalyticsGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const dataAnalytics = !isReduxAction && data ? data : yield call(getDataAnalytics);
    yield put({ type: constants.APP_DATA_ANALYTICS_SUCCEEDED, data : dataAnalytics });
  } catch (error) {
    yield put({ type: constants.APP_DATA_ANALYTICS_FAILED, error });
  }
}

export function* showMPButtonGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const MPButton = !isReduxAction && data ? data : yield call(getshowMPButton);
    yield put({ type: constants.APP_MP_BUTTON_SUCCEEDED, data : MPButton });
  } catch (error) {
    yield put({ type: constants.APP_MP_BUTTON_FAILED, error });
  }
}

export function* transferInfoGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const transferInfo = !isReduxAction && data ? data : yield call(getTransferInfo);
    yield put({ type: constants.APP_TRANSFER_INFO_SUCCEEDED, data : transferInfo });
  } catch (error) {
    yield put({ type: constants.APP_TRANSFER_INFO_FAILED, error });
  }
}

export function* clientGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const client = !isReduxAction && data ? data : yield call(getClient);
    yield put({ type: constants.APP_CLIENT_SUCCEEDED, data : client });
  } catch (error) {
    yield put({ type: constants.APP_CLIENT_FAILED, error });
  }
}

export function* clientsGet(data = []) {
  try {
    const clients = Array.isArray(data) ? data : [];
    setRuntimeClients(clients);
    yield put({ type: constants.APP_CLIENTS_SUCCEEDED, data: clients });
  } catch (error) {
    yield put({ type: constants.APP_CLIENTS_FAILED, error });
  }
}

export function* enviosGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const envios = !isReduxAction && data ? data : yield call(getEnvios);
    yield put({ type: constants.APP_ENVIOS_SUCCEEDED, data: envios });
  } catch (error) {
    yield put({ type: constants.APP_ENVIOS_FAILED, error });
  }
}

export function* onlyUsersGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const onlyUsers = !isReduxAction && data ? data : yield call(getOnlyUsers);
    yield put({ type: constants.APP_ONLYUSERS_SUCCEEDED, data: onlyUsers });
  } catch (error) {
    yield put({ type: constants.APP_ONLYUSERS_FAILED, error });
  }
}

export function* publicKeyMPGet(data = null) {
  try {
    const publicKeyMP = data;
    yield put({ type: constants.APP_PUBLICKEYMP_SUCCEEDED, data : publicKeyMP });
  } catch (error) {
    yield put({ type: constants.APP_PUBLICKEYMP_FAILED, error });
  }
}

export function* cuotasMPGet(data = null) {
  try {
    const cuotasMP = data;
    yield put({ type: constants.APP_CUOTASMP_SUCCEEDED, data : cuotasMP });
  } catch (error) {
    yield put({ type: constants.APP_CUOTASMP_FAILED, error });
  }
}

export function* paymentMethodsGet(data = null) {
  try {
    const paymentMethods = data;
    yield put({ type: constants.APP_PAYMENT_METHODS_SUCCEEDED, data: paymentMethods });
  } catch (error) {
    yield put({ type: constants.APP_PAYMENT_METHODS_FAILED, data: error });
  }
}

export function* addressesGet(data = null) {
  try {
    const isReduxAction = data && data.type;
    const addresses = !isReduxAction && data ? data : yield call(getAddresses);
    yield put({ type: constants.APP_ADDRESSES_SUCCEEDED, data: addresses });
  } catch (error) {
    yield put({ type: constants.APP_ADDRESSES_FAILED, error });
  }
}

export function* frequentQuestionsGet(data = null) {
  try {
    yield put({
      type: constants.APP_FREQUENT_QUESTIONS_SUCCEEDED,
      data: { items: data?.items || [] },
    });
  } catch (error) {
    yield put({ type: constants.APP_FREQUENT_QUESTIONS_FAILED, error });
  }
}

export function* watchApp() {
  yield all([
    takeLatest(constants.APP_INITIALIZE_REQUESTED, loadInitialData),
    takeLatest(cartConstants.CART_CHECKOUT_SUCCEEDED, loadInitialData),

  ]);
}
